import {
  Component,
  inject,
} from '@angular/core';
import {
  AsyncPipe,
  ViewportScroller,
} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Store} from '@ngrx/store';
import {ContentSectionsComponent} from '../../components/content-sections/content-sections.component';
import {HeaderComponent} from '../../components/header/header.component';
import {AppState} from '../../store/store';
import {selectBrokerName} from '../../store/contact/contact.selectors';
import {HtmlContentComponent} from '../../components/html-content/html-content.component';
import {
  selectAdviceEnabledBroker,
  selectBrokerAdvice,
  selectCommissionEnabled,
  selectPensionCommission,
} from '../../store/portal/portal.selectors';
import {BackButtonComponent} from '../../components/back-button/back-button.component';
import {PageTitleComponent} from '../../components/page-title/page-title.component';
import {CommonSpacerComponent} from '../../components/common-spacer/common-spacer.component';
import {FooterInfoComponent} from '../../components/footer-info/footer-info.component';

@Component({
  selector: 'app-advice',
  imports: [TranslatePipe, AsyncPipe, HeaderComponent, BackButtonComponent, PageTitleComponent, CommonSpacerComponent,
    HtmlContentComponent, ContentSectionsComponent, FooterInfoComponent],
  templateUrl: './advice.component.html',
  styleUrl: './advice.component.scss',
})
export class AdviceComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  private viewportScroller: ViewportScroller = inject(ViewportScroller);

  readonly brokerName$ = this.store.select(selectBrokerName);

  readonly pensionCommission$ = this.store.select(selectPensionCommission);

  readonly brokerAdvice$ = this.store.select(selectBrokerAdvice);

  readonly commissionEnabled$ = this.store.select(selectCommissionEnabled);

  readonly brokerEnabled$ = this.store.select(selectAdviceEnabledBroker);

  constructor() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

}
